import { render, staticRenderFns } from "./SettingOverview.vue?vue&type=template&id=454b4c63&scoped=true&"
import script from "./SettingOverview.vue?vue&type=script&lang=js&"
export * from "./SettingOverview.vue?vue&type=script&lang=js&"
import style0 from "./SettingOverview.vue?vue&type=style&index=0&id=454b4c63&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "454b4c63",
  null
  
)

export default component.exports